export enum BannerCategory {
  AppSponsor = 1,
  Sponsor = 2,
  FreeSpace = 3,
}

export enum BannerInvoiceStatus {
  Created = 0,
  Paid = 1,
  Unpaid = 2,
}

export enum BannerPlacement {
  Dashboard = 1,
  NewsDetails = 3,
}

export enum BannerDisplayOptions {
  MobileApp = '["1"]',
  Desktop = '["2"]',
  NotificationSection = '["3"]',
  Everywhere = '["4"]',
}
